export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8698.0127e74b.jpg";